import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { sortSelections } from 'src/domains/layouts/utils/sortSelections';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { calculateRaceStatus } from 'src/domains/sportsbook/utils/filterRacesWithFinishState';
import { HorseRacingSortOrderType } from 'src/domains/sportsbook/webview/components/raceCard/RaceCompetition.state';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import { sortSelectionsByCriteria } from 'src_common/utils/sport/sort';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { HorseRacingRow } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRow/HorseRacing/HorseRacingRow';
import { Collapse } from 'src/ui/components/collapse/sports/04/Collapse';
import {
    HorseRacingRowWrapper,
    RaceSummaryListWrapper,
    RaceSummaryNoHistory,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/horseRacing/RaceSummaryHorseRacing.style';
import { RaceSummaryHorseRacingState } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/horseRacing/RaceSummaryHorseRacing.state';
import { HeadersHorseRacing } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/horseRacing/HeadersHorseRacing';

const getSortOrder = (sortOrder?: HorseRacingSortOrderType, displayOrder?: string): string => {
    if (sortOrder !== null && sortOrder !== undefined) {
        return sortOrder;
    }

    return displayOrder !== undefined && displayOrder !== '-' ? displayOrder : 'by-creation';
};

interface RaceSummaryHorseRacingPropsType {
    marketId: MarketId;
    type?: string;
    isSpecials?: boolean;
    isAntePost?: boolean;
    sortOrder?: HorseRacingSortOrderType;
}

export const RaceSummaryHorseRacing = observer('RaceSummaryHorseRacing', (props: RaceSummaryHorseRacingPropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const [state] = useState(() => new RaceSummaryHorseRacingState());

    const { isAntePost, isSpecials, marketId, sortOrder, type } = props;

    const marketModel = marketId.getModel();
    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const selections = sortSelections(marketModel.selections).filter(
        (selection: SelectionModel): boolean => selection.display === true
    );

    const isPriceOnly = marketModel.newTemplateId === 'win-only';

    const hidePriceHistoryColumn =
        selections.find((selection) => selection.priceHistory.length > 0) === undefined || isPriceOnly === true;

    const displayOrder = marketModel.displayOrderTag;
    const order = getSortOrder(sortOrder, displayOrder);
    const itemsForView = sortSelectionsByCriteria(selections, order);

    const raceStatus = calculateRaceStatus(eventModel.timeSettingsTimeline, eventModel.state);

    const isRaceInProgress = raceStatus === 'RaceStatusInProgress';

    const marketName = marketModel.name.trim();

    return (
        <RaceSummaryNoHistory variant={configState.componentVariants.sportsbookVariant}>
            {isSpecials === true ? (
                <Collapse
                    isOpen={state.isExpanded}
                    title={marketName}
                    handleToggle={state.onExpand}
                />
            ) : null}

            <RaceSummaryListWrapper
                isOpen={state.isExpanded}
                variant={configState.componentVariants.sportsbookVariant}
            >
                <HeadersHorseRacing
                    type={type}
                    market={marketModel}
                    isSpecials={isSpecials}
                    isAntePost={isAntePost}
                    isPriceOnly={isPriceOnly}
                    isPriceHistoryHidden={hidePriceHistoryColumn}
                />

                <HorseRacingRowWrapper variant={configState.componentVariants.sportsbookVariant}>
                    {itemsForView.map((selection) => (
                        <HorseRacingRow
                            key={selection.id2.key}
                            selectionId={selection.id2}
                            type={type}
                            isSpecials={isSpecials}
                            isRaceInProgress={isRaceInProgress}
                            isPriceHistoryHidden={hidePriceHistoryColumn}
                        />
                    ))}
                </HorseRacingRowWrapper>
            </RaceSummaryListWrapper>
        </RaceSummaryNoHistory>
    );
});
